import {useMutation} from '@apollo/react-hooks';

import type {
    ArchiveGroup as ArchiveGroupMutation,
    ArchiveGroupVariables as ArchiveGroupMutationVariables,
    EmailSequenceTemplateGroupArchiveInput,
} from 'nutshell-graphql-types';

import ARCHIVE_GROUP from '../mutations/archive-group.graphql';

export function useArchiveEmailSequenceTemplateGroup(): {
    archiveGroup: (arg1: EmailSequenceTemplateGroupArchiveInput) => Promise<any>;
    isArchiving: boolean;
} {
    const [archiveGroup, {loading}] = useMutation<
        ArchiveGroupMutation,
        ArchiveGroupMutationVariables
    >(ARCHIVE_GROUP);

    return {
        archiveGroup: (input: EmailSequenceTemplateGroupArchiveInput) =>
            archiveGroup({
                variables: {input},
            }),
        isArchiving: loading,
    };
}
